<!--
TODO: refactor (too long, move tab items to components)
-->
<template>
  <v-main v-if="id">
    <v-container class="fill-height" v-if="job" fluid>
      <v-row>
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline">{{ job.clientRef }}</v-list-item-title>
              <v-list-item-subtitle>T2 Job #{{ job.jobNr }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12">
          <v-tabs>
            <v-tab>Details</v-tab>
            <v-tab>Parts</v-tab>
            <v-tab>Notes</v-tab>
            <v-tab>Files</v-tab>
            <v-tab-item>
              <v-card class="px-4 py-4 mt-4 grey lighten-5" v-if="job">
                <v-row dense>
                  <v-col cols="2">
                    <v-text-field v-model="job.jobNr" label="Job #" dense hide-details outlined
                    background-color="white" readonly />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field :value="dateFormat(job.startDate)" label="Date Created"
                      persistent-hint dense hide-details outlined background-color="white" readonly
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field :value="dateFormat(job.closed)" label="Date Closed"
                      persistent-hint dense hide-details outlined background-color="white" readonly
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-model="job.priority" label="Priority" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="job.status" label="Status" dense hide-details outlined
                      readonly background-color="white" />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="job.finalKpa" label="Final KPA" dense hide-details
                      outlined readonly background-color="white" />
                  </v-col>
                </v-row>
                <v-row dense class="my-3">
                  <v-col cols="2">
                    <v-text-field
                      v-model="job.clientRef" label="Client Ref #" dense hide-details outlined
                      readonly background-color="white" />
                  </v-col>
                  <v-col cols="5" v-if="$store.state.details">
                    <v-autocomplete
                      :items="$store.state.details.products.items.map((a) => a.title).sort()"
                      v-model="job.product" label="Product #1" dense hide-details outlined readonly
                      background-color="white"
                    />
                  </v-col>
                  <v-col cols="5" v-if="$store.state.details">
                    <v-autocomplete
                      :items="$store.state.details.products.items.map((a) => a.title).sort()"
                      v-model="job.product2" label="Product #2" dense hide-details outlined readonly
                      background-color="white"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <v-text-field
                      v-model="job.name" label="Customer" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="job.email" label="Email" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="job.supplierTitle" label="Service Agent" dense hide-details outlined
                      readonly background-color="white" />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="job.phone" label="Phone" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="job.mobile" label="Mobile" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="job.fax" label="Fax" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="job.other" label="Other" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="job.address" label="Address" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="job.townSuburb" label="Town / Suburb" dense hide-details outlined
                      readonly background-color="white" />
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete
                      :items="['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NZ']"
                      v-model="job.state" label="State" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-model="job.postcode" label="Postcode" dense hide-details outlined readonly
                      background-color="white" />
                  </v-col>
                </v-row>
                <v-row dense class="my-3">
                  <v-col cols="8">
                    <v-text-field
                      v-model="job.faultInformation" label="Fault Information" dense hide-details
                      outlined background-color="white" readonly />
                  </v-col>
                  <v-col cols="8">
                    <v-textarea
                      v-model="job.description" label="Description" dense hide-details outlined
                      rows="5" background-color="white" readonly />
                  </v-col>
                </v-row>
                <v-row dense class="my-3">
                  <v-col cols="2">
                    <v-text-field :value="dateFormat(job.datePurchased)" label="Date of Purchase"
                      persistent-hint dense hide-details outlined background-color="white" readonly
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="job.purchasedFrom" label="Place of Purchase" dense hide-details
                      outlined readonly background-color="white" />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="job.licenseNr" label="Serial Number" dense outlined
                    background-color="white" hide-details />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="job.builderInstall" label="Builder / Install"
                      dense outlined
                      background-color="white" hide-details />
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="job.contactNr" label="Contact #" dense outlined
                    background-color="white" hide-details />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-4 py-4 mt-4" v-if="job.parts">
                <v-data-table
                  :headers="[
                    { text: 'Date', value: 'dateOrdered' },
                    { text: 'Quantity', value: 'quantity' },
                    { text: 'Part', value: 'partOrdered' },
                  ]"
                  :items="job.parts.items"
                  :items-per-page="5"
                  class="hover-cursor-pointer">
                  <template v-slot:item.dateOrdered="{ item }">
                    {{ dateFormat(item.dateOrdered) }}
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-4 py-4 mt-4">
                <v-row>
                  <v-col cols="10">
                    <v-textarea
                      label="Note"
                      v-model="noteValue"
                      outlined
                      rows="3"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-btn @click="addNote" class="info">Add note</v-btn>
                  </v-col>
                </v-row>
                <template v-if="job.jobNotes.items.length > 0">
                  <template v-for="(note,index) in job.jobNotes.items">
                    <v-row v-if="note.owner" :key="index">
                      <v-col cols="6" class="py-0 caption grey--text">
                        <strong>{{ note.owner || 'Administrator' }}</strong>
                        {{ dateFormat(note.createdAt) }}
                        ({{ humanizedDate(note.createdAt) }} ago)
                      </v-col>
                      <v-col cols="6" class="py-0 text-right caption grey--text">
                      </v-col>
                      {{ note.followUp }}
                      <v-col cols="12" class="py-0 pb-3 body-2">
                        <p v-for="(text, index) in note.note.split('\n')" :key="index">
                          {{ text }}
                        </p>
                      </v-col>
                    </v-row>
                  </template>
                </template>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="px-4 py-4 mt-4">
                <v-row>
                  <v-col>
                    <v-file-input
                      multiple
                      v-model="filesToUpload"
                      label="Select Image or PDF..."
                      accept="image/*, video/*, application/pdf"
                    ></v-file-input>
                    <v-btn color="primary" @click="onUpload">Upload</v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="uploadedFiles.length > 0">
                  <v-col cols="6" v-for="(uploadedFile,index) in uploadedFiles" :key="index">
                    <v-dialog v-model="lightboxDialog[index]" width="600">
                      <template v-slot:activator="{ on }">
                        <v-card :loading="loading" class="text-center">
                          <v-card-text :set="ext = uploadedFile.fileName.split('.').pop()">
                            <a :href="uploadedFile.signedUrl" v-if="ext == 'pdf'" target="_blank">
                              <v-img src="@/assets/64px-PDF_file_icon.svg.png" class="mx-auto"
                                height="79" width="64" />
                            </a>
                            <a v-on="on" v-else-if="supportedThumbnailFormats.includes(ext)">
                              <v-img :src="uploadedFile.signedUrl" />
                            </a>
                            <a v-else target="_blank" class="text-decoration-none"
                              :href="uploadedFile.signedUrl">
                              <big class="display-1">{{ ext.toUpperCase() }}</big>
                            </a>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn :href="uploadedFile.signedUrl" :download="uploadedFile.fileName"
                              target="_blank" class="mx-auto" text>
                              <v-icon>
                                mdi-download
                              </v-icon>
                              Download
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </template>
                      <v-card :loading="loading">
                        <v-img :src="uploadedFile.signedUrl" />
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import * as queries from '@/graphql/queries';
import * as mutations from '@/graphql/mutations';
import {
  Storage,
  API,
  graphqlOperation,
} from 'aws-amplify';

export default {
  title: 'foo',
  props: ['id'],
  data() {
    return {
      supportedThumbnailFormats: ['jpg', 'jpeg', 'png'],
      lightboxDialog: [],
      filesToUpload: [],
      uploadedFiles: [],
      loading: false,
      job: null,
      statusText: 'Success',
      noteValue: null,
      status_items: [
        'Planned',
        'Completed',
        'Cancelled',
        'Processed',
        'Booked',
        'Waiting on ...',
        'Pending Co ...',
        'Stock Pickup',
        'Inspect &amp; A ...',
        'Customer to ...',
        'Allocation R ...',
      ],
      // status: 'foo',
      breadcrumbs: [
        { text: 'Dashboard', to: '/', exact: true },
        { text: 'Jobs', exact: true, to: '/jobs' },
        { text: this.id, disabled: true },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const response = await API.graphql(graphqlOperation(queries.getJob, { id: this.id }));
      this.job = response.data.getJob;

      if (this.job.jobNotes) {
        this.job.jobNotes.items.sort(
          (a, b) => this.moment(b.createdAt) - this.moment(a.createdAt),
        );
      }

      const lastBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 1];
      lastBreadcrumb.text = `${this.job.name}`;

      Storage.list(`${this.job.jobNr}/`)
        .then((result) => {
          result.forEach((item) => {
            if (item.size > 0) {
              Storage.get(item.key)
                .then((signedUrl) => {
                  this.uploadedFiles.unshift({
                    signedUrl,
                    fileName: item.key,
                  });
                })
                .catch((err) => console.log(err));
            }
          });
        })
        .catch((err) => console.log(err));
    },
    async addNote() {
      const response = await API.graphql(graphqlOperation(mutations.createJobNote, {
        input: {
          note: this.noteValue,
          jobNoteJobId: this.id,
          sharedWith: ['clients', 'suppliers'],
        },
      }));

      API.graphql(graphqlOperation(queries.clientEvent, {
        subject: `Job #${this.job.jobNr} - Note added`,
        message: `Note added to ${this.job.status}.\n\n${this.noteValue}`,
      })).catch((err) => console.log(err));

      this.job.jobNotes.items.unshift(response.data.createJobNote);
      this.noteValue = null;
      this.$root.$emit('snackbar-flash', { text: 'Note added' });

      API.graphql(graphqlOperation(mutations.createJobAction, {
        input: {
          action: 'Note added to Job',
          jobId: this.id,
        },
      }));

      this.init();
    },
    onUpload() {
      this.filesToUpload.forEach((fileToUpload, index) => {
        if (fileToUpload.name) {
          const ext = fileToUpload.name.split('.').pop();
          const filename = `${this.job.jobNr}/${this.moment().format('YYYYMMDDhhmmss')}-${index}.${ext}`;
          Storage.put(filename, fileToUpload, { contentType: fileToUpload.type })
            .then((result) => {
              Storage.get(result.key)
                .then((signedUrl) => {
                  this.uploadedFiles.unshift({
                    signedUrl,
                    fileName: result.key,
                  });
                })
                .catch(console.err);
            })
            .catch(console.err);
        }
        API.graphql(graphqlOperation(mutations.createJobAction, {
          input: {
            action: 'File(s) added to job',
            jobId: this.id,
          },
        })).catch(console.err);
        this.snackbar = true;
        this.filesToUpload = null;
      });
    },
    humanizedDate(fromDate) {
      const now = this.moment(new Date());
      const end = this.moment(fromDate);
      const duration = this.moment.duration(now.diff(end));
      return duration.humanize();
    },
  },
};
</script>
